export default __webpack_public_path__ + "static/media/gift.5ec16507.svg";